import React from 'react';
import { motion } from 'framer-motion';
import OticonMoreOverviewBg from '../images/ui/dark-blue-bg.jpg';
import MagentaLine from './elements/MagentaLine';
import VideoBg from '../video/oticon-more-overview-bg.mp4';

export default function OticonMoreOverview() {
  const container = {
    /* ul animation */
    show: {
      transition: {
        delayChildren: 2.0,
        staggerChildren: 0.4,
      },
    },
  };

  const item = {
    /* li animation */
    hidden: { opacity: 0, x: -100 },
    show: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };
  return (
    <div id="oticon-more-overview-wrapper">
      <img src={OticonMoreOverviewBg} className="full-bg" />
      <motion.video
        src={VideoBg}
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="110px" left="40px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '48px',
              left: '40px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Introducing Oticon More™
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '84px',
              left: '40px',
              letterSpacing: '0.85px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            The world's first hearing aid giving the brain{' '}
            <strong>the full perspective</strong>
          </motion.div>
        </div>
      </header>

      <motion.ul variants={container} initial="hidden" animate="show">
        <motion.li variants={item}>
          Oticon More works more like the brain, because it learned through
          experience
        </motion.li>
        <motion.li variants={item}>
          The world's first hearing aid with an embedded deep neural network
          (DNN)
        </motion.li>
        <motion.li variants={item} id="short-width">
          Fundamentally new approaches to signal processing:{' '}
          <span>MoreSound Intelligence™</span>
          <br />
          and MoreSound Amplifier™
        </motion.li>
        <motion.li variants={item} id="wide-width">
          BrainHearing research: <span>Proven to deliver</span>
          <br />
          more and clearer sound to the brain for better speech understanding
        </motion.li>
        <motion.li variants={item}>
          A state-of-the-art rechargeable solution full of options
        </motion.li>
      </motion.ul>
      <motion.div
        className="footnote"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 4.4 }}
      >
        *Android devices need to support ASHA to allow direct streaming to
        Oticon More. Please visit oticon.com/support/compatibility for more
        information.
      </motion.div>
    </div>
  );
}
